export default __webpack_public_path__ + "static/searchNotFound-43203572f9b803074c36bc757c8e2baa.svg";